const QUALTRICS_ZONE_ID = 'ZN_O9HPTlV3IX4jfeF'
const QUALTRICS_SCRIPT_ID = 'qualtrics-site-intercept-script'
const QUALTRICS_SCRIPT_URL =
  'https://zno9hptlv3ix4jfef-remaxcx.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_O9HPTlV3IX4jfeF'
const QUALTRICS_APP_EVENTS = [
  { eventName: 'MottoRep', matches: ['mottorep', 'birdeye'] },
  { eventName: 'MottoSpark', matches: ['mottospark'] },
  { eventName: 'MottoLearn', matches: ['mottolearn'] },
  { eventName: 'wemlo', matches: ['wemlo'] },
  { eventName: 'Website', matches: ['website', 'mottowebsite'] },
]
const QUALTRICS_APP_EVENTS_BY_OKTA_NAME = {
  birdeye: 'MottoRep',
  mottomortgage_totalexpert_1: 'MottoSpark',
  mottomortgage_mottolearn_1: 'MottoLearn',
  mottomortgage_wemlo_1: 'wemlo',
  mottomortgage_lhp_1: 'Website',
}

let hasStarted = false

export function initQualtricsIntercept(externalReference) {
  if (isProductionEnvironment()) {
    return
  }

  if (externalReference === undefined || externalReference === null || externalReference === '') {
    return
  }

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return
  }

  try {
    window.QSI = window.QSI || {}
    window.QSI.config = {
      ...(window.QSI.config || {}),
      externalReference,
    }

    if (hasStarted || document.getElementById(QUALTRICS_SCRIPT_ID)) {
      return
    }

    hasStarted = true
    startQualtrics()
  } catch (error) {}
}

export function trackQualtricsAppClick(appName) {
  if (isProductionEnvironment()) {
    return
  }

  const eventName = getQualtricsAppEventName(appName)
  if (!eventName || typeof window === 'undefined') {
    return
  }

  try {
    window._qsie = window._qsie || []
    window._qsie.push(eventName)
  } catch (error) {}
}

function startQualtrics() {
  const loadScript = () => {
    if (!document.body || document.getElementById(QUALTRICS_SCRIPT_ID)) {
      return
    }

    ensureZoneContainer()

    const script = document.createElement('script')
    script.id = QUALTRICS_SCRIPT_ID
    script.type = 'text/javascript'
    script.src = QUALTRICS_SCRIPT_URL
    document.body.appendChild(script)
  }

  if (document.readyState === 'complete') {
    loadScript()
    return
  }

  window.addEventListener('load', loadScript, false)
}

function getQualtricsAppEventName(appName) {
  const normalizedAppName = normalizeAppName(appName)

  if (!normalizedAppName) {
    return null
  }

  if (QUALTRICS_APP_EVENTS_BY_OKTA_NAME[normalizedAppName]) {
    return QUALTRICS_APP_EVENTS_BY_OKTA_NAME[normalizedAppName]
  }

  const appEvent = QUALTRICS_APP_EVENTS.find(({ matches }) =>
    matches.some((value) => normalizedAppName.includes(value))
  )
  return appEvent?.eventName || null
}

function normalizeAppName(appName) {
  return (appName || '').toString().replace(/\s/g, '').toLowerCase()
}

function isProductionEnvironment() {
  return process.env.APP_ENV === 'prod'
}

function ensureZoneContainer() {
  if (document.getElementById(QUALTRICS_ZONE_ID)) {
    return
  }

  const container = document.createElement('div')
  container.id = QUALTRICS_ZONE_ID
  container.innerHTML = '<!--DO NOT REMOVE-CONTENTS PLACED HERE-->'
  document.body.appendChild(container)
}
